import { useCallback, useState } from 'react';

const SlideToggle = ({ collapsed = false, children }) => {
	const [isCollapsed, setIsCollapsed] = useState(collapsed);

	const toggle = useCallback(() => {
		setIsCollapsed((value) => !value);
	}, []);

	const setCollapsibleElement = useCallback(
		(element) => {
			if (!element) return;

			element.style.overflow = 'hidden';
			element.style.maxHeight = isCollapsed ? '0px' : `${element.scrollHeight}px`;
			element.style.transition = 'max-height 0.25s ease';
		},
		[isCollapsed]
	);

	return children({
		toggle,
		setCollapsibleElement,
		isCollapsed,
	});
};

export default SlideToggle;
